module.exports = __webpack_public_path__ + "static/media/user-icon.a652ee0a.svg";